import { useRef, useState } from 'react'
import { UpdateProviderProfile, GetProviderProfileExternalData, UploadProviderPricing, GetProviderProfileInfo } from '../../api/endpoints/ProviderProfile'
import { LoadListDefault, useGet, useUpdate } from '../../api/hooks'
import useForm from '../../hooks/useForm'
import { useTranslation } from 'react-i18next'
import '../ProvidersRRDetails/style.css'
import { SERVICE_TYPES } from '../../data/Constant'
import useFormData from '../../hooks/useFormData'
import ProfileData from './ProfileData'
import EditProfile from './EditProfile'
import { Icon } from '@iconify/react'
import './style.css'
import { CRRender } from '@/component/crRender'
import { useLoadImg } from '@/hooks/useLoadImg'
import ActionBtn from '@/component/ActionBtn'

const ProviderProfile = () => {

  const { t } = useTranslation()
  const [isEditMode, setIsEditMode] = useState(false)

  const { result: providerInfo, isPending } = useGet({ ...LoadListDefault, params: [], allowFetch: true, depArr: [], endPoint: GetProviderProfileInfo })


  console.log(providerInfo, isPending);

  const handleSaveSuccess = () => {
    setIsEditMode(false)
    // Optionally refetch data here
  }


  return (
    <>
      {/* View Mode Header with Edit Button */}
      <div className="provider-profile-header">
        <h2 className="provider-profile-title">{t("provider-profile")}</h2>
        <div className="provider-profile-actions">
          <button
            onClick={() => setIsEditMode(true)}
            className="edit-profile-button"
          >
            <Icon icon="mdi:pencil" className="edit-profile-button-icon" />
            {t("edit-profile")}
          </button>
        </div>
        <CRRender isRender={!!isEditMode}>
          <ActionBtn
            title="cancel"
            onApply={() => setIsEditMode(false)}
            className="btn-secondary"
          />
        </CRRender>
      </div>
      <CRRender isRender={!!isEditMode}>
        <EditProfile providerInfo={providerInfo} isPending={isPending} onCancel={() => setIsEditMode(false)} onSaveSuccess={handleSaveSuccess} />
      </CRRender>
      <CRRender isRender={!isEditMode}>
        <ProfileData requestDetails={providerInfo} isPending={isPending} />
      </CRRender>

    </>
  )
}

export default ProviderProfile
